import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { uniqueAndSorted } from "@faire/retailer-visitor-shared/lib/uniqueAndSorted";
import { createCategoryPageQueryKeyPrefix } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/__internal__/createCategoryPageQueryKeyPrefix";
export var createCategoryPageQueryKeys = function(param) {
    var navigationPath = param.navigationPath, filterKeys = param.filterKeys, oneIndexedPageNumber = param.oneIndexedPageNumber, requestReferrer = param.requestReferrer;
    return _to_consumable_array(createCategoryPageQueryKeyPrefix({
        navigationPath: navigationPath
    })).concat([
        uniqueAndSorted(filterKeys),
        oneIndexedPageNumber,
        requestReferrer
    ]);
};
